import { render, staticRenderFns } from "./TableServices.vue?vue&type=template&id=0cb7147e"
import script from "./TableServices.vue?vue&type=script&lang=js"
export * from "./TableServices.vue?vue&type=script&lang=js"
import style0 from "./TableServices.vue?vue&type=style&index=0&id=0cb7147e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports